import { Component, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { AuthService, CmsNavigationComponent } from '@spartacus/core';
import { CmsComponentData, LaunchDialogService, NavigationService } from '@spartacus/storefront';
import { take } from 'rxjs/operators';

@Component({
  selector: 'custom-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  isUserlogged$ = this.auth.isUserLoggedIn();

  @ViewChild('open') openElement!: ElementRef;

  node$ = this.service.getNavigationNode(this.componentData.data$);

  logout() {
    this.auth.logout();
  }

  openDialog() {
    const dialog = this.launchDialogService.openDialog('TERMS_CONDITIONS', this.openElement, this.vcr);
    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  constructor(
    private service: NavigationService,
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private auth: AuthService,
    private launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef
  ) {}
}
